import queryString from 'query-string'
import { buildSurveyPath } from 'contexts/survey-context/survey-path'
import { Trivia } from 'contexts/trivia-context/reducer'

/** Backend error code returned by survey validation when the survey was already answered. */
export const PREVIOUS_SURVEY_ANSWERED_CODE = 860

/** Query param that tells the trivia view to skip the intro modal and start the game. */
export const TRIVIA_INTRO_ACCEPTED_PARAM = 'introAccepted'

type PreviousSurveyFlags = Pick<Trivia, 'showPreviousSurvey' | 'previousSurveyId'>

/**
 * Returns the id of the survey that must be answered before the trivia can be
 * played, or `null` when the trivia does not require one.
 */
export function needsPreviousSurvey(trivia: PreviousSurveyFlags | null | undefined): number | null {
  if (!trivia?.showPreviousSurvey) return null

  const surveyId = trivia.previousSurveyId
  if (typeof surveyId !== 'number' || surveyId <= 0) return null

  return surveyId
}

export const buildPreviousSurveyPath = buildSurveyPath

/**
 * Builds the trivia url the survey should return to, keeping the current query
 * params (e.g. UTM on `/trivia/qr/:id`) and flagging the intro as accepted.
 */
export function buildTriviaReturnPath(pathname: string, search: string): string {
  const query = { ...queryString.parse(search), [TRIVIA_INTRO_ACCEPTED_PARAM]: 'true' }
  return `${pathname}?${queryString.stringify(query)}`
}

/** True only when the intro accepted flag arrives as the literal string "true". */
export function isIntroAccepted(query: Record<string, unknown>): boolean {
  return query?.[TRIVIA_INTRO_ACCEPTED_PARAM] === 'true'
}
